import axiosInstance from "../../api/axiosInstance";
import { createStore } from "vuex";
import dashboardStore from "./modules/dashboard.store";
import sessionStore from "./modules/sessions.store";
import studentsStore from "./modules/students.store";
import episodesStore from "./modules/episodes.store";
import classRoomsStore from "./modules/classRooms.store";
import curriculumStore from "./modules/curriculum.store";
import paymentsStore from "./modules/payments.store";
import subscriptionsStore from "./modules/subscriptions.store";
import notificationsStore from "./modules/notifications.store";
import groupAdminStore from "./modules/groupAdmin.store";
export default createStore({
  state: {
    toast: {
      type: null,
      message: null,
      duration: null,
    },
    accountModalShow: false,
    notificationModalShow: false,
    adminBannerHidden: false,
    countries: {},
    states: {},
    institutionTypes: [],
    surveyOptions: [],
    jobTypeOptions: [],
    iceServers: [],
    cancelSurveyOptions: [],
  },
  getters: {
    toast: (state) => state.toast,
    accountModalShow: (state) => state.accountModalShow,
    notificationModalShow: (state) => state.notificationModalShow,
    adminBannerHidden: (state) => state.adminBannerHidden,
    countries: (state) => state.countries,
    states: (state) => state.states,
    institutionTypes: (state) => state.institutionTypes,
    surveyOptions: (state) => state.surveyOptions,
    jobTypeOptions: (state) => state.jobTypeOptions,
    iceServers: (state) => state.iceServers,
    cancelSurveyOptions: (state) => state.cancelSurveyOptions,
  },
  mutations: {
    showToast(state, { type, message, duration }) {
      state.toast = { type, message, duration };
    },
    toggleAccountModal(state, show = true) {
      state.accountModalShow = show;
    },
    toggleNotificationModal(state, show = true) {
      state.notificationModalShow = show;
    },
    setAdminBannerHidden(state, hidden) {
      state.adminBannerHidden = hidden;
    },
    setAccountSettings(state, settings) {
      state.countries = settings.countries;
      state.states = settings.states;
      state.institutionTypes = settings.institution_types;
    },
    setStates(state, states) {
      state.states = states;
    },
    setSurveyOptions(state, surveyOptions) {
      state.surveyOptions = surveyOptions;
    },
    setJobTypeOptions(state, jobTypeOptions) {
      state.jobTypeOptions = jobTypeOptions;
    },
    setIceServers(state, iceServers) {
      state.iceServers = iceServers;
    },
    setCancelSurveyOptions(state, cancelSurveyOptions) {
      state.cancelSurveyOptions = cancelSurveyOptions;
    },
  },
  actions: {
    showToast({ commit }, { type, message, duration }) {
      commit("showToast", { type, message, duration });
    },
    toggleAccountModal({ commit }, show = true) {
      commit("toggleAccountModal", show);
    },
    toggleNotificationModal({ commit }, show = true) {
      commit("toggleNotificationModal", show);
    },
    setAdminBannerHidden({ commit }, hidden) {
      commit("setAdminBannerHidden", hidden);
    },
    loadAccountSettings({ commit }) {
      return axiosInstance
        .get("/account_settings")
        .then((response) => {
          commit("setAccountSettings", response.data);
          return response;
        })
        .catch((error) => error.response);
    },
    loadStates({ commit }, country) {
      return axiosInstance
        .get("/load_states", {
          params: {
            country: country,
          },
        })
        .then((response) => {
          commit("setStates", response.data || {});
          return response;
        })
        .catch((error) => error.response);
    },
    loadSurveyOptions({ commit }) {
      return axiosInstance
        .get("/survey_options")
        .then((res) => {
          commit("setSurveyOptions", res.data.survey_options);
          commit("setJobTypeOptions", res.data.job_type_options);
          return res;
        })
        .catch((e) => e.response);
    },
    loadIceServers({ commit }) {
      return axiosInstance
        .get("/ice_servers")
        .then((res) => {
          commit("setIceServers", res.data);
          return res;
        })
        .catch((e) => e.response);
    },
    loadCancelSurveyOptions({ commit }) {
      return axiosInstance
        .get("/cancel_survey_options")
        .then((res) => {
          commit("setCancelSurveyOptions", res.data);
          return res;
        })
        .catch((e) => e.response);
    },
  },
  modules: {
    dashboard: dashboardStore,
    sessions: sessionStore,
    students: studentsStore,
    episodes: episodesStore,
    classRooms: classRoomsStore,
    curriculum: curriculumStore,
    payments: paymentsStore,
    subscriptions: subscriptionsStore,
    notifications: notificationsStore,
    groupAdmin: groupAdminStore,
  },
});
